export default __webpack_public_path__ + "static/media/address.c7478a54.png";